var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        {
          attrs: { layout: "", "align-center": "", "justify-space-between": "" }
        },
        [
          _c(
            "v-flex",
            { staticClass: "headline", attrs: { md1: "", "mb-3": "" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { dark: "", color: "primary" },
                  on: {
                    click: function($event) {
                      _vm.addStoreDialog = true
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { dark: "" } }, [_vm._v("add")]),
                  _vm._v(" " + _vm._s(_vm.$t("store")) + "\n      ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-2 myDense",
        attrs: {
          headers: _vm.headers,
          items: _vm.stores,
          "rows-per-page-items": _vm.rowPerPage
        },
        on: {
          "update:items": function($event) {
            _vm.stores = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(props) {
              return [
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.index + 1))
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.accountId))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.accountName))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.platform))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.countryCode || "US"))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.status))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.isAuthorize))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(_vm.toTimestampString(props.item.createTime)))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { attrs: { "text-xs-center": "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { dark: "", color: "primary", flat: "" },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.toAuthorize(props.item)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    props.item.isAuthorize
                                      ? _vm.$t("reAuthorize")
                                      : _vm.$t("authorize")
                                  ) + "\n            "
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  dark: "",
                                  color: "primary",
                                  flat: "",
                                  loading:
                                    _vm.deleteStoreLoading &&
                                    props.item.isLoading
                                },
                                on: {
                                  click: function($event) {
                                    $event.stopPropagation()
                                    return _vm.deleteStore(props.item)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("delete")))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _vm.addStoreDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("fillInStoreInformation"),
              rightMethod: _vm.addStoreSubmitted,
              rightButtonDisabled: !_vm.isEmpty,
              medium: ""
            },
            on: {
              popupClose: function($event) {
                _vm.addStoreDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-flex",
                        { attrs: { md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.platforms,
                              label: _vm.$t("platform")
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function(data) {
                                    return [
                                      [
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c(
                                              "v-list-tile-title",
                                              { attrs: { id: data.item } },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(data.item) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              733259306
                            ),
                            model: {
                              value: _vm.platform,
                              callback: function($$v) {
                                _vm.platform = $$v
                              },
                              expression: "platform"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md3: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.countryCodes,
                              label: _vm.$t("countryCode")
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item",
                                  fn: function(data) {
                                    return [
                                      [
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c(
                                              "v-list-tile-title",
                                              { attrs: { id: data.item } },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(data.item) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              733259306
                            ),
                            model: {
                              value: _vm.countryCode,
                              callback: function($$v) {
                                _vm.countryCode = $$v
                              },
                              expression: "countryCode"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { attrs: { md5: "" } },
                        [
                          _c("v-text-field", {
                            staticClass: "required_field",
                            attrs: {
                              label: _vm.$t("storeName"),
                              rules: [_vm.isDuplicateName]
                            },
                            model: {
                              value: _vm.accountName,
                              callback: function($$v) {
                                _vm.accountName = $$v
                              },
                              expression: "accountName"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1085369345
            ),
            model: {
              value: _vm.addStoreDialog,
              callback: function($$v) {
                _vm.addStoreDialog = $$v
              },
              expression: "addStoreDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.walmartAuthorizeDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("fillInAuthorizeInformation"),
              rightMethod: _vm.walmartAuthorizeSubmit,
              rightButtonDisabled: !_vm.isWalmartAuthorizeEmpty,
              medium: ""
            },
            on: {
              popupClose: function($event) {
                _vm.walmartAuthorizeDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _vm.store.platform === "walmart"
                        ? [
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { md6: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("clientId"),
                                        rules: [_vm.isDuplicateName]
                                      },
                                      model: {
                                        value: _vm.authorizeClientId,
                                        callback: function($$v) {
                                          _vm.authorizeClientId = $$v
                                        },
                                        expression: "authorizeClientId"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          dark: "",
                                          flat: "",
                                          color: "primary"
                                        },
                                        on: { click: _vm.authorizeHelp }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("authorizeHelp")))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { md6: "" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "required_field",
                                  attrs: {
                                    label: _vm.$t("clientSecret"),
                                    rules: [_vm.isDuplicateName]
                                  },
                                  model: {
                                    value: _vm.authorizeClientSecret,
                                    callback: function($$v) {
                                      _vm.authorizeClientSecret = $$v
                                    },
                                    expression: "authorizeClientSecret"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        : [
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { md6: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("shopName"),
                                        rules: [_vm.isDuplicateName]
                                      },
                                      model: {
                                        value: _vm.authorizeClientId,
                                        callback: function($$v) {
                                          _vm.authorizeClientId = $$v
                                        },
                                        expression: "authorizeClientId"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          dark: "",
                                          flat: "",
                                          color: "primary"
                                        },
                                        on: { click: _vm.authorizeHelp }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("authorizeHelp")))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { md6: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: { label: _vm.$t("token") },
                                      model: {
                                        value: _vm.accessToken,
                                        callback: function($$v) {
                                          _vm.accessToken = $$v
                                        },
                                        expression: "accessToken"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3469557240
            ),
            model: {
              value: _vm.walmartAuthorizeDialog,
              callback: function($$v) {
                _vm.walmartAuthorizeDialog = $$v
              },
              expression: "walmartAuthorizeDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.shopifyAuthorizeDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("fillInAuthorizeInformation"),
              rightMethod: _vm.shopifyAuthorizeSubmit,
              rightButtonDisabled: !_vm.isShopifyAuthorizeEmpty,
              medium: ""
            },
            on: {
              popupClose: function($event) {
                _vm.shopifyAuthorizeDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      [
                        _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              { attrs: { md6: "" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "required_field",
                                  attrs: {
                                    label: _vm.$t("shopName"),
                                    rules: [_vm.isDuplicateName]
                                  },
                                  model: {
                                    value: _vm.authorizeClientId,
                                    callback: function($$v) {
                                      _vm.authorizeClientId = $$v
                                    },
                                    expression: "authorizeClientId"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      dark: "",
                                      flat: "",
                                      color: "primary"
                                    },
                                    on: { click: _vm.authorizeHelp }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("authorizeHelp")))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              { attrs: { md6: "" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "required_field",
                                  attrs: { label: _vm.$t("token") },
                                  model: {
                                    value: _vm.accessToken,
                                    callback: function($$v) {
                                      _vm.accessToken = $$v
                                    },
                                    expression: "accessToken"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1786247983
            ),
            model: {
              value: _vm.shopifyAuthorizeDialog,
              callback: function($$v) {
                _vm.shopifyAuthorizeDialog = $$v
              },
              expression: "shopifyAuthorizeDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.temuAuthorizeDialog
        ? _c("FormSubmitPopup", {
            attrs: {
              title: _vm.$t("fillInAuthorizeInformation"),
              value: _vm.temuAuthorizeDialog,
              rightMethod: _vm.temuAuthorizeSubmit,
              rightButtonDisabled: _vm.isTemuAuthorizeEmpty,
              medium: ""
            },
            on: {
              popupClose: function($event) {
                _vm.temuAuthorizeDialog = false
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "input",
                  fn: function() {
                    return [
                      _c(
                        "v-layout",
                        { attrs: { "justify-between-space": "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md10: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "required_field",
                                attrs: {
                                  label: "Access Token",
                                  rules: [_vm.fieldIsRequired()]
                                },
                                model: {
                                  value: _vm.temuForm.accessToken,
                                  callback: function($$v) {
                                    _vm.$set(_vm.temuForm, "accessToken", $$v)
                                  },
                                  expression: "temuForm.accessToken"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    dark: "",
                                    flat: "",
                                    color: "primary"
                                  },
                                  on: { click: _vm.authorizeHelp }
                                },
                                [_vm._v(_vm._s(_vm.$t("authorizeHelp")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              1062505946
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.staticAuthorizeDialog
        ? _c("HelpManualPopup", {
            ref: "HelpManualPopup",
            attrs: {
              isShow: _vm.staticAuthorizeDialog,
              title: _vm.$t("authorizeHelpDetails"),
              helpManualFileUrl: _vm.platformAuthHelp
            },
            model: {
              value: _vm.staticAuthorizeDialog,
              callback: function($$v) {
                _vm.staticAuthorizeDialog = $$v
              },
              expression: "staticAuthorizeDialog"
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e220bb8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e220bb8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StoreSettings.vue
// module id = null
// module chunks = 